// Toast notifications and promise-based confirm dialogs.
//
//   toast.success('Opgeslagen');
//   toast.error(errorMessage(err));
//   toast.show({ message: 'Verwijderd', action: { label: 'Ongedaan maken', run: undo } });
//   if (await confirm({ title: 'Verwijderen?', danger: true })) …

import { prefs } from './prefs.svelte';

export interface Toast {
  id: number;
  kind: 'info' | 'success' | 'error' | 'warning';
  message: string;
  description?: string;
  action?: { label: string; run: () => void };
  duration: number;
}

class Toasts {
  items = $state<Toast[]>([]);
  private seq = 0;

  show(t: Partial<Toast> & { message: string }) {
    const id = ++this.seq;
    const toast: Toast = { id, kind: 'info', duration: t.action ? 6000 : 3800, ...t };
    this.items = [...this.items.slice(-3), toast];
    if (toast.duration > 0) setTimeout(() => this.dismiss(id), toast.duration);
    return id;
  }
  success(message: string, description?: string) {
    return this.show({ kind: 'success', message, description });
  }
  error(message: string, description?: string) {
    return this.show({ kind: 'error', message, description, duration: 6000 });
  }
  warning(message: string, description?: string) {
    return this.show({ kind: 'warning', message, description, duration: 5000 });
  }
  info(message: string, description?: string) {
    return this.show({ kind: 'info', message, description });
  }
  dismiss(id: number) {
    this.items = this.items.filter((t) => t.id !== id);
  }
}

export const toast = new Toasts();

export interface ConfirmOptions {
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  /** Ask the user to type this text to confirm (irreversible actions). */
  typeToConfirm?: string;
  /** Skip the dialog when the user turned delete confirmations off. */
  skippable?: boolean;
}

class Dialogs {
  current = $state<(ConfirmOptions & { resolve: (ok: boolean) => void }) | null>(null);

  confirm(opts: ConfirmOptions): Promise<boolean> {
    if (opts.skippable && !prefs.value.confirmDeletes) return Promise.resolve(true);
    return new Promise((resolve) => {
      this.current?.resolve(false);
      this.current = { ...opts, resolve };
    });
  }

  close(ok: boolean) {
    const c = this.current;
    this.current = null;
    c?.resolve(ok);
  }
}

export const dialogs = new Dialogs();
export const confirm = (opts: ConfirmOptions) => dialogs.confirm(opts);
